export const validationRunner = (field, name, ...validations) => {
  return (state) => {
    for (let v  of validations) {
      let errorMessageFunc = v(state[field], state);
      if (errorMessageFunc) {
        return {[field]: errorMessageFunc(name)};
      }
    }
    return null;
  };
};


const innerrun = (state, runners) => {
  return runners.reduce((errors, runner) => {
    return Object.assign(errors, runner(state));
  }, {});
};

export function run(runners) {
  const errors = innerrun(this.state, runners);
  if (Object.keys(errors).length !== Object.keys(this.state.validationErrors).length) {
    this.setState({validationErrors: errors})
    return errors;
  }
  for (var key in errors) {
    if (errors[key] !== this.state.validationErrors[key]) {
      this.setState({validationErrors: errors})
    }
  }
  return errors;
}



// WEBPACK FOOTER //
// ./src/validation/validationRunner.jsx